class Accordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.content = this.querySelector(".accordion-content");
    this.label = this.querySelector(".accordion-label");
    this.childAccordions = this.querySelectorAll("accordion-element");
    this.closeOnCLick = this.dataset.close === "true";
    this.label.addEventListener("click", () => {
      this.toggle();
    });
    if (this.closeOnCLick) {
      this.content.querySelectorAll("a").forEach((el) => {
        el.addEventListener("click", () => {
          this.close();
        });
      });
    }
    this.optionInfoValue = this.querySelector(".option-info-value");
    for (const optionSwitcher of this.querySelectorAll(".option-switcher")) {
      const options = [...optionSwitcher.querySelectorAll("label")];
      let active = options[0];
      options.forEach((option) => {
        option.addEventListener("click", () => {
          active.classList.remove("active");
          option.classList.add("active");
          active = option;
          this.optionInfoValue.innerText = option.innerText.toLowerCase();
        });
      });
    }
  }
  disconnectedCallback() {}
  expand = (init = false) => {
    if (this.label.ariaExpanded === "true") return;
    this.dataset.hasParents &&
      this.id &&
      document
        .querySelectorAll(`accordion-element:has(#${this.id})`)
        .forEach((el) => el.expand(init));
    this.label.ariaExpanded = true;
    if (init) {
      this.content.style.height = "unset";
      return;
    }
    this.content.style.height = this.content.scrollHeight + "px";
    setTimeout(() => {
      this.content.style.height = "unset";
    }, 250);
  };
  close = () => {
    if (this.label.ariaExpanded === "false") return;
    this.label.ariaExpanded = false;
    this.content.style.height = this.content.scrollHeight + "px";

    setTimeout(() => {
      this.content.style.height = "0px";
    });
    this.childAccordions.forEach((el) => el.close());
  };
  toggle = () => {
    this.label.ariaExpanded === "true" ? this.close() : this.expand();
  };
}
customElements.define("accordion-element", Accordion);
